/**
 * Dependencies.
 */
import { BaseModel, endpoint, prop } from '@prz-dp/services';

/**
 * Model `OrderRequestModel`.
 */
@endpoint('deliveryRequest')
export default class OrderRequestModel extends BaseModel {
  /**
   * Properties.
   */
  @prop()
  collectId?: number;

  @prop()
  deliveryId?: number;

  @prop()
  isAutomatic?: boolean;

  // For delivery requests of the type message.
  @prop()
  messages?: {
    id: number;

    deliveryRequestId: number;

    isRead: boolean;

    message: string;

    recordDate: string;

    source: string;
  }[];

  @prop()
  orderType: 'DELIVERY' | 'COLLECT';

  @prop()
  request: {
    // Address, delivery request.
    address: {
      additionalInformation?: string;

      city?: string;

      countryCode?: string;

      countryName?: string;

      doorNumber?: number;

      latitude?: number;

      longitude?: number;

      street?: string;

      zipCode?: string;
    };

    // Date, delivery request.
    date?: string;

    // Message, delivery request.
    message?: string;
  };

  @prop()
  type: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<OrderRequestModel>) {
    super(data);
  }
}
